import { NativeCurrency, Token, WETH9 } from '@kodiak-finance/sdk-core'
import {
  BeraNativeCurrency,
  BUSD_BEPOLIA as BUSD_BEPOLIA_ROUTER,
  BUSD_BERA as BUSD_BERA_ROUTER,
  CBBTC_ROBINHOOD as CBBTC_ROBINHOOD_ROUTER,
  ExtendedEther,
  isBera as isBera_Router,
  MCD_ROBINHOOD as MCD_ROBINHOOD_ROUTER,
  NVDA_ROBINHOOD as NVDA_ROBINHOOD_ROUTER,
  SHROOM_ROBINHOOD as SHROOM_ROBINHOOD_ROUTER,
  SPY_ROBINHOOD as SPY_ROBINHOOD_ROUTER,
  USDC_BERA as USDC_BERA_ROUTER,
  USDG_ROBINHOOD as USDG_ROBINHOOD_ROUTER,
  USDT_BERA as USDT_BERA_ROUTER,
  WBTC_BERA as WBTC_BERA_ROUTER,
  WETH_BERA as WETH_BERA_ROUTER,
} from '@kodiak-finance/smart-order-router'
import { SupportedChainId } from 'config/chains'

export const BUSD_BERA = BUSD_BERA_ROUTER
export const USDC_BERA = USDC_BERA_ROUTER
export const USDT_BERA = USDT_BERA_ROUTER
export const WETH_BERA = WETH_BERA_ROUTER
export const WBTC_BERA = WBTC_BERA_ROUTER
export const BUSD_BEPOLIA = BUSD_BEPOLIA_ROUTER
export const USDG_ROBINHOOD = USDG_ROBINHOOD_ROUTER
export const SPY_ROBINHOOD = SPY_ROBINHOOD_ROUTER
export const NVDA_ROBINHOOD = NVDA_ROBINHOOD_ROUTER
export const SHROOM_ROBINHOOD = SHROOM_ROBINHOOD_ROUTER
export const MCD_ROBINHOOD = MCD_ROBINHOOD_ROUTER
export const CBBTC_ROBINHOOD = CBBTC_ROBINHOOD_ROUTER

export const WRAPPED_NATIVE_CURRENCY: { [chainId in SupportedChainId]: Token } = Object.fromEntries(
  Object.entries(WETH9)
    .filter(([chainId]) => Number(chainId) in SupportedChainId)
    .map(([chainId, token]) => [Number(chainId) as SupportedChainId, token])
) as { [chainId in SupportedChainId]: Token }

export function isBera(chainId: number): boolean {
  return isBera_Router(chainId)
}

export function isRobinhood(chainId: number): boolean {
  return chainId === SupportedChainId.ROBINHOOD
}

const cachedNativeCurrency: { [chainId: number]: NativeCurrency | Token } = {}
export function nativeOnChain(chainId: number): NativeCurrency | Token {
  if (cachedNativeCurrency[chainId]) return cachedNativeCurrency[chainId]
  let nativeCurrency: NativeCurrency | Token
  if (isBera(chainId)) {
    nativeCurrency = new BeraNativeCurrency(chainId)
  } else {
    nativeCurrency = ExtendedEther.onChain(chainId)
  }
  return (cachedNativeCurrency[chainId] = nativeCurrency)
}

export const BUSD_ADDRESS = '0xFCBD14DC51f0A4d49d5E53C2E0950e0bC26d0Dce'

const TOKEN_PROMOTION_BERA = new Token(80094, BUSD_ADDRESS, 18, 'BUSD', 'Bera USD')

export const PROMOTE_TOKENS_BY_CHAIN: { [chainId in SupportedChainId]?: Token } = {
  [SupportedChainId.BERA]: TOKEN_PROMOTION_BERA,
  [SupportedChainId.ROBINHOOD]: USDG_ROBINHOOD,
}

export const BGT_ADDRESS = '0x656b95E550C07a9ffe548bd4085c72418Ceb1dba'
